import React, { useState, useEffect, useCallback } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

export default function VideoGallery() {
  const [video, setVideo] = useState([]);

  const fetchVideo = useCallback(async () => {
    try {
      const response = await fetch(`/api/getVideo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const Data = await response.json();
        setVideo(Data);
      } else {
        console.error("Error fetching filtered data");
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  }, []);

  useEffect(() => {
    fetchVideo();
  }, [fetchVideo]);

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <>
      <section className="bg-gradient-to-r from-blue-950 to-blue-900 py-24 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold" data-aos="fade-down">
            Video Gallery
          </h1>
          <p className="mt-3 text-sky-100 text-base md:text-lg" data-aos="fade-up" data-aos-delay="150">
            A Visual Journey Through Memorable Moments at <span className="scholarVarsity">Fatehpur Public School</span>
          </p>
        </div>
      </section>

      <div className="container my-5 py-5 bg-light text-dark shadow-lg p-3 mb-5 bg-white rounded">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900" data-aos="fade-up">
            Discover Our Engaging Video Gallery
          </h2>
          <div className="w-24 h-1 bg-[#F4B400] mx-auto mt-4 rounded-full" data-aos="zoom-in" data-aos-delay="150"></div>
        </div> 
        <div className="row">
          {video.map((video, index) =>
            <div key={index} className={`col-md-4 ${index === 0 ? 'active' : ''}`} data-aos="zoom-in" data-aos-delay={index * 120}>
              <div className="image-containers shadow p-3 mb-5 bg-white rounded">
                <iframe width="100%" height="175" src={video.VideoURL} title={video.VideoTitle} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" className="embed-responsive-item" allowFullScreen></iframe>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
